import { Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import useFilter from "../../../../../hook/useFilter"
import { orderActions } from "../../../../../store/orders-slice"
import { productActions } from "../../../../../store/products-slice"
import { producttypeActions } from "../../../../../store/producttype-slice"

const Resort = (props) => {
       const { type, name } = props
       const { resort } = useFilter()
       let filteredproducttypes = useSelector((state) => state.producttype.filteredProducttypes)
       let producttypes=useSelector(state=>state.producttype.producttypes)
       let dispatch = useDispatch()
   
       return <Fragment>
           <label>{name}</label><select className="mb-2"
               onChange={(event) => {
                   let value = event.target.value
   
                   switch (value) {
                       case 'ASC':
                           dispatch(producttypeActions.setFilteredItems(resort(filteredproducttypes??producttypes, type, 'ASC')))
                           break
   
                       case 'DESC':
                           dispatch(producttypeActions.setFilteredItems(resort(filteredproducttypes??producttypes, type, 'DESC')))
                           break
                   }
   
               }}
   
           >
               <option value='' >Sort</option>
               <option value='ASC' >Ascending</option>
               <option value='DESC' >Descending</option>
           </select>
       </Fragment>
}

export default Resort